// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l1-0";
export var assigneeDetails = "_l1-1";
export var assigneeInfo = "_l1-2";
export var dropdownContainer = "_l1-4";
export var dropdownImage = "_l1-5";
export var editAssigneeInfo = "_l1-3";
export var editAssigneeModalContainer = "_l1-6";
export var hidden = "_l1-8";
export var input = "_l1-7";